import { FC } from 'react';
import { Upload, UploadProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { Button } from '../../ui/button';
import type { UploadTranslations } from '../types';
import styles from '../FileUploader.module.scss';

interface InlineControlsProps {
    uploadProps: UploadProps;
    disabled?: boolean;
    hasUpload: boolean;
    translations: UploadTranslations;
    onStart: () => void;
}

export const InlineControls: FC<InlineControlsProps> = ({
    uploadProps,
    disabled,
    hasUpload,
    translations,
    onStart,
}) => {
    return (
        <div className={styles.inlineControls}>
            <Upload {...uploadProps} className={styles.uploadButton}>
                <Button variant="small" htmlType="button" disabled={disabled}>
                    {translations.selectFile}
                </Button>
            </Upload>
            <Button
                variant="small"
                icon={<UploadOutlined />}
                onClick={onStart}
                htmlType="button"
                disabled={disabled || !hasUpload}
            >
                {translations.upload}
            </Button>
        </div>
    );
};
